export default function (cli) {
  return {
    login (username, password) {
      return cli.post(`${cli.apiEndpoint}accounts/login/`)
        .send({ username, password })
    },
    profile () {
      return cli.get(`${cli.apiEndpoint}accounts/profile/`)
    },
  }
}



// WEBPACK FOOTER //
// ./src/api/account.js